import React from 'react';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';

interface Props {
	id: string;
	onDelete: (id: string) => void;
}

const ManagerInsuranceCompaniesBatchCreateTableDelete = ({
	id,
	onDelete,
}: Props) => {
	return (
		<LinkButton
			title='base.shared.remove'
			theme={Theme.RED}
			onClick={() => onDelete(id)}
		/>
	);
};

export default ManagerInsuranceCompaniesBatchCreateTableDelete;
